/* eslint-disable one-var */
/* eslint-disable prettier/prettier */

import { AbstractControl, UntypedFormGroup } from '@angular/forms';
import {
  EntityParams,
  EntityService,
  IMenuItemLs
} from 'viggo-sistemas-core-web';

/* eslint-disable no-restricted-properties */
export class Utils {
  /**
   * Remove as informações com NULL para undefined
   * @param obj
   */
  static deleteUnusualObj<T>(obj: T): T {
    Object.keys(obj).forEach(v => {
      if (obj[v] === null || obj[v] === undefined) {
        delete obj[v];
      }
    });
    return obj;
  }

  /**
   * Remove as informações com NULL para undefined
   * @param obj
   */
  static clearObject<T>(obj: T): T {
    Object.keys(obj).forEach(v => {
      if (obj[v] === null) {
        obj[v] = undefined;
      }
    });
    return obj;
  }

  /**
   * Remove as informações com UNDEFINED para NULL
   * @param obj
   */
  static clearEmptyString<T>(obj: T): T {
    Object.keys(obj).forEach(v => {
      if (obj[v] === '') {
        obj[v] = null;
      }
    });
    return obj;
  }

  /**
   * Remove os espaços em branco dentro dos atributos
   * @param obj
   */
  static trimAttributes<T>(obj: T): T {
    const regexWhiteSpaces = /\s/;
    Object.keys(obj).forEach(v => {
      if (typeof obj[v] === 'string' && regexWhiteSpaces.test(obj[v])) {
        obj[v] = obj[v].trim();
      }
    });
    return obj;
  }

  /**
   * Remove as informações com NULL ou undefined
   * @param obj
   */
  static clearObjectInfo<T>(obj: T): T {
    Object.keys(obj).forEach(v => {
      if (obj[v] === null || obj[v] === undefined) {
        delete obj[v];
      }
    });
    return obj;
  }

  static onlyAttributes(object: any, attributes: string[]): any {
    const filtered = Object.keys(object)
      .filter(
        key =>
          attributes.includes(key) &&
          object[key] !== undefined &&
          object[key] !== null
      )
      .reduce((obj, key) => {
        obj[key] = object[key];
        return obj;
      }, {});

    return filtered;
  }

  /**
   * Adiciona a fração de 2 digitos em decimais
   * @param valor
   * @param fraction
   * @returns
   */
  static toFixedNumber(valor: string | number = '', fraction = 2): string {
    const result = Number(valor);

    if (Number.isNaN(result)) return '';

    return new Intl.NumberFormat('pt-BR', {
      maximumFractionDigits: fraction,
      minimumFractionDigits: fraction
    }).format(result);
  }

  /**
   * Altera um valor string com mascara para o valor numérico.
   * @example 10,00 -> 10 ou 10,10 -> 10.1
   * @param valor valor a ser formatado
   */
  static replaceCommaToDot(valor: string | number): number {
    if (valor === null || valor === undefined) return null;

    if (typeof valor === 'number') return valor;

    if (typeof valor === 'string' && valor.includes('.'))
      return Number.parseFloat(valor);

    return Number.parseFloat(
      valor
        .replace(/((\.)([0-9]{1,3}$))/, ',$3')
        .replace(/\./g, '')
        .replace(/,/, '.')
        .replace(' ', '')
    );
  }

  /**
   * Altera um valor string com mascara para o valor numérico.
   * @example 10,00 -> 10 ou 10,10 -> 10.1
   * @param valor valor a ser formatado
   */
  static replaceDotToComma(valor: string | number, qtdZeros = 2): string {
    if (valor === null || valor === undefined) return null;

    if (typeof valor === 'number') {
      valor = valor.toString().replace('.', ',');
      const splitLen = valor.split(',').length > 1;
      if (splitLen) {
        const spliCommatLen = valor.split(',')[1].length;
        for (let i = 0; i < qtdZeros - spliCommatLen; i++) {
          valor = valor.concat('0');
        }
      } else {
        for (let i = 0; i < qtdZeros; i++) {
          if (i === 0) {
            valor = valor.concat(',0');
          } else {
            valor = valor.concat('0');
          }
        }
      }
      return valor;
    } else if (
      typeof valor === 'string' &&
      !valor.includes('.') &&
      !(valor === '.00' || valor === '')
    ) {
      for (let i = 0; i < qtdZeros; i++) {
        if (i === 0) {
          valor = valor.concat(',0');
        } else {
          valor = valor.concat('0');
        }
      }
      return valor.replace('.', ',');
    } else if (typeof valor === 'string' && (valor === '.00' || valor === '')) {
      for (let i = 0; i < qtdZeros; i++) {
        if (i === 0) {
          valor = valor.concat('0,0');
        } else {
          valor = valor.concat('0');
        }
      }
      return valor.replace('.', ',');
    }

    return valor.replace('.', ',');
  }

  /**
   * Converter um enumerado para objeto
   * @param enumObject
   * @returns
   */
  public static enumToLisObjet(enumObject): { value: string; label: string }[] {
    return Object.keys(enumObject).map(key => ({
      value: key,
      label: enumObject[key].replace(/_/gi, ' ')
    }));
  }
  /** Retorna objeto do enumerado
   * @param enumObject
   * @returns
   * */
  public static getEnumValue(vl, enumObject) {
    const k = Object.keys(enumObject).find(key => vl === key);
    return enumObject[k];
  }
  /**
   * Aplica as regras de ABNT 5891/77 na conversão de valores decimais
   * @regra1 valor a ser conservado é seguido de um valor menor que 5 EX: 5,221 -> 5,2
   * @regra2 valor a ser conservado é seguido de um valor maior ou igual a 5 e seguido de outro diferente de 0 EX: 5,762 -> 5,8
   * @regra3 valor a ser conservado for impar, seguido de um valor igual a 5 seguido de um 0 EX: 18,550 -> 18,6
   * @regra4 valor a ser conservado for par, seguido de um valor igual a 5 seguido de um 0 EX: 18,650 -> 18,6
   * @param valor valor a ser formatado
   * @param precision número da precisão vinda da regra de dominio
   */
  public static converteABNT(valor: string | number, precision = 2): number {
    if (valor === null || valor === undefined) return null;

    if (typeof valor === 'string') {
      if (valor.includes(',')) {
        valor = this.replaceCommaToDot(valor);
      } else if (valor.includes('.')) {
        valor = Number(valor);
      } else if (Number.isInteger(Number(valor))) {
        return Number(valor);
      } else {
        // console.error('Valor inválido para conversão!');
        return 0;
      }
    } else {
      if (valor.toString().includes(',')) {
        valor = this.replaceCommaToDot(valor);
      } else if (valor.toString().includes('.')) {
        valor = Number(valor);
      } else if (Number.isInteger(valor)) {
        return Number(valor);
      } else {
        console.error('Valor inválido para conversão!');
        return null;
      }
    }
    valor = Number.parseFloat(valor.toString());
    var negativo = valor < 0;
    var delta = 0.00001;
    var pow_aux = Math.pow(10, precision);
    var pow_value = Math.abs(valor) / 10;
    var int_value = Math.trunc(pow_value);
    var frac_value = Number.parseFloat(
      '0.' + pow_value.toString().split('.')[1]
    );
    pow_value =
      ((frac_value * 10 * pow_aux) / Math.pow(10.0, -9) + 0.5) *
      Math.pow(10.0, -9);
    var int_calc = Math.trunc(pow_value);
    var frac_calc = Number.parseFloat(
      '0.' + pow_value.toString().split('.')[1]
    );
    frac_calc = Math.trunc(frac_calc * 100);

    if (frac_calc > 50) {
      int_calc += 1;
    } else if (frac_calc === 50) {
      var valor_temp = int_calc / 10;
      var last_number = Math.round(
        Number.parseFloat('0.' + valor_temp.toString().split('.')[1]) * 10
      );

      if (last_number % 2 === 1) {
        int_calc += 1;
      } else {
        valor_temp = pow_value * 10;
        var rest_part = Number.parseFloat(
          '0.' + valor_temp.toString().split('.')[1]
        );

        if (rest_part > delta) {
          int_calc += 1;
        }
      }
    }
    var resultado = int_value * 10 + int_calc / pow_aux;
    if (negativo) resultado *= -1;
    if (this.isPeriodic(resultado)) {
      resultado = Number(Number(resultado).toFixed(precision));
    }
    return resultado;
  }

  /**
   * Une todos os valores do objeto para um unico nivel
   * @param array
   */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  static flatDeep<T = any>(array: Array<any>): T[] {
    const fn = array.reduce((acc, current) =>
      Array.isArray(current)
        ? acc.concat(Utils.flatDeep(current))
        : array.concat(current)
    );
    return fn;
  }

  /**
   * Retorna o tempo de duração entre uma faixa de datas
   * @param tempoFim - tempo em milisegundos da data-fim
   * @param tempoInicio - tempo em milisegundos da data-inicio
   */
  static remainingTime(tempoFim: number, tempoInicio: number) {
    const diferencaMilisegundos = tempoFim - tempoInicio;

    const diferencaSegundos = Math.floor(diferencaMilisegundos / 1000);
    const diferencaMinutos = Math.floor(diferencaSegundos / 60);
    const diferencaHoras = Math.floor(diferencaMinutos / 60);
    const diferencaDias = Math.floor(diferencaHoras / 24);
    const horasRestantes = diferencaHoras % 24;
    const minutosRestantes = diferencaMinutos % 60;
    const segundosRestantes = diferencaSegundos % 60;

    return {
      dias: diferencaDias,
      horas: horasRestantes,
      minutos: minutosRestantes,
      segundos: segundosRestantes
    };
  }

  static isPeriodic(num: number, maxDigits = 100) {
    const numStr = num.toString();

    const decimalIndex = numStr.indexOf('.');

    if (decimalIndex === -1) return false;

    const decimalPart = numStr.slice(decimalIndex + 1);

    for (let i = 1; i <= decimalPart.length / 2; i++) {
      const block = decimalPart.slice(0, i);
      const repeatedBlock = block.repeat(Math.ceil(decimalPart.length / i));
      if (repeatedBlock.startsWith(decimalPart)) return true;
    }

    const numIsMoreThenLimit = this.moreThenLimit(num, maxDigits);

    return numIsMoreThenLimit;
  }

  static moreThenLimit(num: number, maxDigits = 100): boolean {
    const decimal = num.toString().split('.')[1];
    if (decimal) {
      for (let i = 0; i < decimal.length; i++) {
        const chunk = decimal.substring(i, i + maxDigits);
        // decimal.indexOf(chunk) !== i && decimal.indexOf(chunk) !== -1
        if (decimal.indexOf(chunk) === i && decimal.indexOf(chunk) !== -1) {
          return true;
        }
      }
    }
    return false;
  }

  static blobToString(b) {
    var u, x;
    u = URL.createObjectURL(b);
    x = new XMLHttpRequest();
    x.open('GET', u, false); // although sync, you're not fetching over internet
    x.send();
    URL.revokeObjectURL(u);
    return x.responseText;
  }

  static checkIfValueExist(
    control: AbstractControl<string>,
    entityService: EntityService<any>,
    field: string,
    domainId: string,
    entity_id?: string,
    form?: UntypedFormGroup,
    domainPath = 'domain_id'
  ) {
    if (form) form.setErrors({ duplicate: true });
    if (control.invalid || control.value === '') return;
    const { value } = control;
    if (value) {
      entityService
        .getEntitiesByParams(
          {
            where: {
              [field]: value.trim(),
              [domainPath]: domainId
            } as any,
            pagination: {
              page: 0,
              page_size: 1
            }
          } as EntityParams<any>,
          undefined,
          true
        )
        .subscribe(res => {
          if (res.data.length > 0) {
            if (entity_id !== res.data[0].id) {
              control.setErrors({ duplicate: true });
            } else {
              if (control.hasError('duplicate')) control.setErrors(null);
              if (form) form.setErrors(null);
            }
          } else {
            if (control.hasError('duplicate')) control.setErrors(null);
            if (form) form.setErrors(null);
          }
        });
    }
  }

  static getBreadcrumbMenu(menu: string, subMenu?: string) {
    const menus = (JSON.parse(
      localStorage.getItem('menu_items') &&
        localStorage.getItem('menu_items').length !== 0
        ? localStorage.getItem('menu_items')
        : null
    ) ?? []) as IMenuItemLs[];
    if (menus.length !== 0) {
      if (!subMenu)
        return menus.find(it =>
          (it.label as string)
            .normalize('NFD')
            .replace(/[\u0300-\u036f]/g, '')
            .toUpperCase()
            .includes(menu)
        );
      else {
        const menuAccess = menus.find(it =>
          (it.label as string)
            .normalize('NFD')
            .replace(/[\u0300-\u036f]/g, '')
            .toUpperCase()
            .includes(menu)
        );
        if (menuAccess && menuAccess.items && menuAccess.items.length) {
          return {
            ...menuAccess,
            subMenu: menuAccess.items.find(it =>
              (it.label as string)
                .normalize('NFD')
                .replace(/[\u0300-\u036f]/g, '')
                .toUpperCase()
                .includes(subMenu)
            )
          };
        }
      }
    }
  }

  static findIndexInList<T = any>(value: T, list: T[]): number {
    let index = -1;

    if (list) {
      for (let i = 0; i < list.length; i++) {
        if (list[i] === value) {
          index = i;
          break;
        }
      }
    }

    return index;
  }

  static dataURLtoFile(dataurl, filename) {
    var arr = dataurl.split(','),
      mime = arr[0].match(/:(.*?);/)[1],
      bstr = atob(arr[arr.length - 1]),
      n = bstr.length,
      u8arr = new Uint8Array(n);
    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }
    return new File([u8arr], filename, { type: mime });
  }

  static applyMask(
    valor: number | string,
    casasDecimais: number,
    type?: string
  ) {
    if (
      typeof valor === 'string' &&
      valor.includes(',') &&
      valor.split(',')[1].length === 0
    ) {
      return valor;
    } else {
      valor = valor
        .toString()
        .replace(/((\.)([0-9]{1,3}$))/, ',$3')
        .replace(/\./g, '')
        .replace(/,/, '.')
        .replace(' ', '');

      // Se houver mais de um ponto, mantenha apenas o primeiro
      const partes = valor.split('.');
      if (partes.length > 2) {
        valor = partes[0] + '.' + partes.slice(1).join('');
      }

      // Se houver um ponto, limite as casas decimais
      if (partes.length > 1) {
        const parteInteira = partes[0];
        const parteDecimal = partes[1].substring(0, casasDecimais);
        valor = parteInteira + '.' + parteDecimal;
      }
      return Utils.replaceDotToComma(valor, 0);
    }
  }

  static fillZeros(valor: number | string, casasDecimais: number) {
    valor = valor
      .toString()
      .replace(/((\.)([0-9]{1,3}$))/, ',$3')
      .replace(/\./g, '')
      .replace(/,/, '.')
      .replace(' ', '');
    const partes = valor.toString().split('.');
    // Preenche com zeros se necessário, mas apenas se não houver parte decimal
    if (partes.length === 2 && partes[1].length < casasDecimais) {
      const parteInteira = partes[0];
      const parteDecimal = partes[1].padEnd(casasDecimais, '0');
      valor = (parteInteira === '' ? 0 : parteInteira) + '.' + parteDecimal;
    }

    return this.replaceDotToComma(valor, casasDecimais);
  }

  static convertValorToNumber(valor: number | string) {
    if (valor === null || valor === undefined) return null;

    if (typeof valor === 'string') {
      if (valor.includes(',')) {
        valor = this.replaceCommaToDot(valor);
      } else if (valor.includes('.')) {
        valor = Number(valor);
      } else if (Number.isInteger(Number(valor))) {
        return Number(valor);
      } else {
        // console.error('Valor inválido para conversão!');
        return 0;
      }
    } else {
      if (valor.toString().includes(',')) {
        valor = this.replaceCommaToDot(valor);
      } else if (valor.toString().includes('.')) {
        valor = Number(valor);
      } else if (Number.isInteger(valor)) {
        return Number(valor);
      } else {
        console.error('Valor inválido para conversão!');
        return null;
      }
    }
    return valor;
  }

  static ratearValorTotal(parcelas, valor_total) {
    let aux = 0;
    const qtd_parcelas = parcelas.length;
    const valor_parcela = Utils.converteABNT(valor_total / qtd_parcelas, 2);
    const valor_total_parcelas = Utils.converteABNT(
      valor_parcela * qtd_parcelas,
      2
    );
    const diferenca = Utils.converteABNT(valor_total - valor_total_parcelas, 2);
    parcelas.forEach(parcela => {
      parcela.valor = valor_parcela;
      if (aux === 0) {
        parcela.valor += diferenca;
        aux++;
      }
    });
    return parcelas;
  }

  static async encryptPassword(string) {
    const utf8 = new TextEncoder().encode(string);
    const hashBuffer = await crypto.subtle.digest('SHA-256', utf8);
    const hashArray = Array.from(new Uint8Array(hashBuffer));
    const hashHex = hashArray
      .map(bytes => bytes.toString(16).padStart(2, '0'))
      .join('');
    return hashHex;
  }

  static assignNestedMergeValue(obj: any, path: string, value: any): any {
    const keys = path.split('.');
    let current: any = obj;

    keys.forEach((key, index) => {
      const isLast = index === keys.length - 1;

      if (isLast) {
        const existing = current[key];

        // Se já existe um objeto, faz merge em vez de sobrescrever
        if (typeof existing === 'object' && typeof value === 'object') {
          current[key] = { ...existing, ...value };
        } else {
          current[key] = value; // Caso contrário, sobrescreve normalmente
        }
      } else {
        if (!(key in current) || typeof current[key] !== 'object') {
          current[key] = {};
        }
        current = current[key];
      }
    });

    return obj;
  }

  /**
   * Função recursiva que captura um JSON e vai atribuindo em formato de string para ser
   * um PARAMS de uma URL
   * @param obj
   * @param prefix
   * @returns
   */
  static flattenObject(obj: any, prefix = ''): string[] {
    return Object.entries(obj).flatMap(([key, value]) => {
      const fullKey = prefix ? `${prefix}.${key}` : key;
      if (typeof value === 'object' && value !== null) {
        return this.flattenObject(value, fullKey);
      }
      return [`${fullKey}=${value}`];
    });
  }
}
